import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'
import IconTextGrid from '../../components/content/IconTextGrid'
import SizzleImageGrid from '../../components/multimedia/SizzleImageGrid';
import EnrichedImageGallery from '../../components/multimedia/EnrichedImageGallery'
import FeaturesGallery from '../../components/multimedia/FeaturesGallery'
import ImageWithText from '../../components/multimedia/ImageWithText'
import {theme} from '../../themes/default-theme';

import MediaBanner from '../../components/multimedia/MediaBanner'
import Floorplan from '../Floorplan'
import InteriorDecorModule from '../../components/multimedia/InteriorDecorModule';
import SeriesBodyText from '../../components/content/SeriesBodyText';
import SeriesBigHeroBanner from '../../components/multimedia/SeriesBigHeroBanner';
// import interiorDecorModule from '../../components/multimedia/interiorDecorModule'
import { InView } from 'react-intersection-observer';
import FloorplanMotorised from '../FloorplanMotorised';
import MotorisedTableComparison from '../../components/content/MotorisedTableComparison';

const Wrapper = styled.div`
    ${props => props.colourTheme === 'dark' && `
        background-color: black;
    `}
    &:before,
    &:after {
        content: '';
        display: table
    }
    &:after {
        clear: both
    }
`

const Container = styled.div`
    margin: 120px 0;

    ${theme.breakpoints.down('sm')} {
        margin: 60px 0;
    }

    ${props => props.collapseTop && `
        margin-top: 0;
    `}

    ${props => props.collapseBottom && `
        margin-bottom: 0;
    `}

    ${props => ((props.bg === 'dark' && props.colourTheme === 'light') || (props.bg === 'light' && props.colourTheme === 'dark') || props.bg === 'grey' || (props.bg === 'black' && props.colourTheme !== 'dark') || (props.bg === 'white' && props.colourTheme !== 'light') || (props.bg === 'light' && props.colourTheme !== 'light')) && `
            padding-top:40px;
            padding-bottom:40px; 
        ${theme.breakpoints.up("md")} {
            padding-top:60px;
            padding-bottom:60px; 
        }
        ${theme.breakpoints.up("lg")} {
            padding-top:80px;
            padding-bottom:80px; 
        }
    `}

    ${props => ((props.bg === 'black' && props.colourTheme === 'light') || (props.bg === 'dark' && props.colourTheme === 'dark')) && `
        background-color: black;
    `
    } 

    ${props => ((props.bg === 'grey' && props.colourTheme === 'light') || (props.bg === 'dark' && props.colourTheme === 'light')) &&
    `
        background-color:${theme.palette.lightGrey};
        ` 
    };

    ${props => ((props.bg === 'grey' && props.colourTheme === 'dark') || (props.bg === 'light' && props.colourTheme === 'dark')) &&
    `
        background-color:${theme.palette.shadeBlack};
        ` 
    };

    ${props => ((props.bg === 'white' && props.colourTheme === 'dark')) && `
        background-color: white;
    `
    } 

`

const ContentBuilder = (props) => {
    const {
        rates,
        uri,
        seriesId,
        rangeTitle,
        rangeId,
        onIntersection,
        countryProps
    } = props
    
    console.log('ContentBuilder props', props);

    const colourTheme = props.colourTheme === 'white' || props.colourTheme === 'light' ? 'light' : 'dark';
    const observerSettings = {
        threshold: 0.1,
        rootMargin: '-120px'
    }
    return (
        <Wrapper colourTheme={colourTheme}>
            {(props.items && props.items.length > 0) ? props.items.map((item, index) => {
                const id = item.anchorId ? item.anchorId.replace(/ /g, "-").toLowerCase() : undefined;

                const backgroundColor = item.data.background;

                if (item.type === 'iconTextGrid') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <IconTextGrid
                                    {...item.data}
                                    background={backgroundColor} 
                                    colourTheme={colourTheme}
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'sizzleImageGrid') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <SizzleImageGrid
                                    {...item.data}
                                    colourTheme={colourTheme} 
                                    background={backgroundColor} 
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'enrichedImageGallery') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <EnrichedImageGallery
                                    {...item.data}
                                    background={backgroundColor} 
                                    colourTheme={colourTheme}
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'featuresGallery') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <FeaturesGallery
                                    {...item.data}
                                    colourTheme={colourTheme}
                                    background={backgroundColor} 
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'mediaBanner') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <MediaBanner
                                    {...item.data}
                                    
                                />
                            </Container>
                        </InView>
                    )
                }
                
                if (item.type === 'imageWithText') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <ImageWithText
                                    {...item.data}
                                    background={backgroundColor}
                                />
                            </Container>
                        </InView>
                    )
                }



                if (item.type === 'floorplan' && !props.motorised) {
                    return (

                        <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                            <InView
                                onChange={(e) => onIntersection(e,item)}
                                {...observerSettings}>
                                <Floorplan 
                                    {...item.data}
                                    uri={uri}
                                    seriesId={seriesId}
                                    rangeTitle={rangeTitle}
                                    rangeId={rangeId}
                                    rates={props.rates}
                                    countryProps={countryProps}
                                    colourTheme={backgroundColor === 'white' ? 'light' : colourTheme } 
                                /> 
                            </InView>
                        </Container>
                        
                    )
                }

                if (item.type === 'floorplanMotorised' && props.motorised) {
                    return (

                        <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                            <InView
                                onChange={(e) => onIntersection(e,item)}
                                {...observerSettings}>
                                <FloorplanMotorised
                                    {...item.data}
                                    uri={uri}
                                    seriesId={seriesId}
                                    rangeId={rangeId}
                                    rates={props.rates}
                                    countryProps={countryProps}
                                    colourTheme={backgroundColor === 'white' ? 'light' : colourTheme } 
                                /> 
                            </InView>
                        </Container>
                        
                    )
                }

                if (item.type === 'motorisedTableComparison' && props.motorised) {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <MotorisedTableComparison 
                                    {...item.data}
                                    colourTheme={colourTheme} 
                                    uri={uri}
                                    seriesId={seriesId}
                                    rangeId={rangeId}
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'interiorDecorModule') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <InteriorDecorModule 
                                    {...item.data}
                                    colourTheme={colourTheme} 
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'seriesBodyText') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <SeriesBodyText 
                                    {...item.data}
                                    colourTheme={colourTheme} 
                                />
                            </Container>
                        </InView>
                    )
                }

                if (item.type === 'seriesBigHeroBanner') {
                    return (
                        <InView
                            onChange={(e) => onIntersection(e,item)}
                            {...observerSettings}
                        >
                            <Container key={item.id || index} colourTheme={colourTheme} bg={backgroundColor} collapseBottom={item.collapseBottom} collapseTop={item.collapseTop} id={id}>
                                <SeriesBigHeroBanner
                                    {...item.data}
                                    colourTheme={colourTheme} 
                                />
                            </Container>
                        </InView>
                    )
                }

            }) : null }
        </Wrapper>
    	
    )
}
    
ContentBuilder.propTypes = {
}
    
ContentBuilder.defaultProps = {
    rates: {},
    onIntersection: () => {}
}
    
export default ContentBuilder